export const ContactMap = () => {
  return (
    <div className="col-md-12 mt-4">
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4224.832719885643!2d-0.652968022408347!3d51.521769209652085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487664afdaac5947%3A0xbf7bfa0423ab0a2f!2sAl-Madani%20Masjid!5e1!3m2!1sen!2suk!4v1742833131336!5m2!1sen!2suk"
          width="100%"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Al-Madani Masjid"
        ></iframe>
      </div>
    </div>
  );
};
